// extracted by mini-css-extract-plugin
module.exports = {"main-container":"NewProduct_main-container__Yw8Ph","left-container":"NewProduct_left-container__2z7Ta","right-container":"NewProduct_right-container__3TqHA"};